exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.check-list[data-v-bd7c31dc] {\n  margin-bottom: 20px;\n}\n.word-break[data-v-bd7c31dc] {\n  word-break: break-all;\n}\n.c-btn-back-store[data-v-bd7c31dc]{\n  padding-top: 1em;\n  padding-bottom: 1em;\n}\n", ""]);

// exports
